





import Vue from 'vue'
import { PLANNING_ASSISTANT_GET_FILTERED_EMPLOYEES_BY_DEPARTMENT } from '@/store/getter-types'
import { Employee } from '@/model/companyStructure/Employee'

export default Vue.extend({
  name: 'BooleanCellRenderer',

  computed: {
    icon (): string {
      // @ts-ignore
      if (this.params.data.employeeId) {
        const employees: Array<Employee> = this.$store.getters[PLANNING_ASSISTANT_GET_FILTERED_EMPLOYEES_BY_DEPARTMENT]
        // @ts-ignore
        const result: boolean = employees.some((item: Employee) => item.id === this.params.data.employeeId)

        return result ? 'clear' : 'check'
      }
      return 'clear'
    },

    color (): string {
      // @ts-ignore
      if (this.params.data.employeeId) {
        const employees: Array<Employee> = this.$store.getters[PLANNING_ASSISTANT_GET_FILTERED_EMPLOYEES_BY_DEPARTMENT]
        // @ts-ignore
        const result: boolean = employees.some((item: Employee) => item.id === this.params.data.employeeId)
        return result ? 'red' : 'green'
      }
      return 'red'
    }
  }
})
